(function() {
    function handleVatSelection(vatSelect) {
        const currentCountry = Shopify?.country || "EU";
        let targetValue = "0"; 

        switch (currentCountry) {
            case "GB": targetValue = "1"; break; // UK
            case "AU": targetValue = "2"; break; // ABN 
            case "IN": targetValue = "3"; break; // India GST
            case "US": targetValue = "4"; break; // US EIN
            default:   targetValue = "0"; break; // EU 
        }

        if (vatSelect.value !== targetValue) {
            vatSelect.value = targetValue;
            vatSelect.dispatchEvent(new Event("change", { bubbles: true }));
        }
    }

    const observer = new MutationObserver((mutations, obs) => {
        const vatSelect = document.querySelector(".bss-b2b-vat-selected");
        
        if (vatSelect) {
            handleVatSelection(vatSelect);
            obs.disconnect();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
})();

